import backend, {JOB_API} from 'utils/backend/server/api_library';

const getJob = (jobRn) => {
  const url = `${JOB_API}/career/job/${jobRn}/public`;
  return backend.get(url);
};

export default {
  getJob,
};
